export default __webpack_public_path__ + "static/media/ic-map-white.38550251.svg";